module.exports = __webpack_public_path__ + "static/img/矩形@2x(15).3dbb1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achievements/矩形@2x(15).png
// module id = v5J1
// module chunks = 1